import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    ProjectRequest,
    ProjectRequestParams,
    ProjectRequestTable,
    ProjectRequestWithPage, RequestResource, RequestResourceParams, RequestResourceType,
} from '@app/interfaces/lm/project-request';
import { HardwareVOS, ProjectHardwareTimeLine } from '@app/interfaces/rm/hardware';
import { environment } from '@env/environment';
import { HardwareService } from '@services/rm/hardware.service';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProjectRequestService {
    private moduleApi = environment.api.services.lm;
    private baseUrl = this.moduleApi + '/resource-requests';

    constructor(private http: HttpClient,
                private hardwareService: HardwareService) {}

    async find(params: ProjectRequestParams): Promise<ProjectRequestWithPage> {
        return lastValueFrom(this.http.get<ProjectRequestWithPage>(`${this.baseUrl}`, {
            params: Object.assign(params)
        }));
    }

    async approve(data: {id: string}): Promise<ProjectRequest> {
        return lastValueFrom(this.http.post<ProjectRequest>(`${this.baseUrl}/approve`, data));
    }

    async reject(data: {responseNote: string, id: string}): Promise<ProjectRequest> {
        return lastValueFrom(this.http.post<ProjectRequest>(`${this.baseUrl}/reject`, data));
    }

    async getRequestResourceType(params: {status: string}): Promise<RequestResourceType[]> {
        return lastValueFrom(this.http.get<RequestResourceType[]>(`${this.baseUrl}/resource-type`, {
            params: Object.assign(params)
        }));
    }

    async getRequestResource(params: RequestResourceParams): Promise<RequestResource[]> {
        return lastValueFrom(this.http.get<RequestResource[]>(`${this.baseUrl}/resource`, {
            params: Object.assign(params)
        }));
    }

    async getResourceData(content: ProjectRequest[]): Promise<ProjectRequestTable[]> {
        if (!content || content.length <= 0) {
            return [] as ProjectRequestTable[];
        }
        const hardwareIds = content?.map((item: ProjectRequest) => item?.hardwareId).filter(hardwareId => hardwareId);
        const hardwares = hardwareIds && hardwareIds.length > 0 ? await this.hardwareService.find({ hardwareIds }) : [];
        const hardwareList: ProjectHardwareTimeLine[] = [];
        if (hardwares && hardwares.length > 0) {
            hardwares.forEach(item => {
                hardwareList.push(...item.hardwareVOS);
            });
        }
        return content?.map((item: ProjectRequest) => {
            const hardwareData = hardwareList?.find((hardwareItem) => hardwareItem.hardwareId === item.hardwareId);
            return {
                ...item,
                ...hardwareData
            };
        });
    }

}
